import React from 'react';
import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';
import { useT } from 'src/i18n';

import './Steps.scss';

export const Steps = () => {
  const t = useT();
  const [stepOne, stepTwo, stepThree] = t.steps.items;

  return (
    <>
      <StepBlock step={stepOne} modifier="steps-block_step-one" />
      <StepBlock step={stepTwo} modifier="steps-block_step-two" liClass="li_purple" />
      <StepBlock step={stepThree} modifier="steps-block_step-three" />
    </>
  );
};

const StepBlock = ({ step, modifier, liClass = 'li_green' }) => (
  <div className={`steps-block ${modifier}`}>
    <Fade>
      <StepHeading parts={step.headingParts} />
    </Fade>

    <Slide left duration={1200}>
      {step.list.map((text) => (
        <StepListItem
          key={text}
          text={text}
          className={`li ${liClass}`}
        />
      ))}
    </Slide>
  </div>
);

const StepHeading = ({ parts }) => (
  <h1 className="steps-block__heading">
    {parts[0]}
    {parts[1] && <span className="steps-block__heading_800">{parts[1]}</span>}
    {parts[2] && <span className="steps-block__heading_700">{parts[2]}</span>}
    {parts[3] && <span className="steps-block__heading_600">{parts[3]}</span>}
    {parts[4] && <span className="steps-block__heading_500">{parts[4]}</span>}
    {parts[5] && <span className="steps-block__heading_normal">{parts[5]}</span>}
  </h1>
);

const StepListItem = ({ className, text }) => {
  if (text.includes('\n')) {
    const [lineOne, lineTwo] = text.split('\n');

    return (
      <div className="steps-block__li steps-block__li_multi">
        <div className={`${className} li_multi`} />
        <span className="steps-block__li-text">
          {lineOne}
          <br />
          {lineTwo}
        </span>
      </div>
    );
  }

  return (
    <div className="steps-block__li">
      <div className={className} />
      <span className="steps-block__li-text">{text}</span>
    </div>
  );
};
